import * as React from "react";
import RadioButton from "./RadioButton";
import {FaMinus} from "react-icons/fa";
import Checkbox from "./Checkbox";

const GuestInput = ({ id, isAttending, canDelete, guest, onGuestChange, onGuestDelete }) => {

  const handleChange = (ev) => {
    const key = ev.target.name.split('.')[1];
    const updated = {
      ...guest,
      [key]: ev.target.type === 'checkbox' ? ev.target.checked : ev.target.value
    };
    if (!isAttending) {
      delete guest.food;
      delete guest.brunch;
    }
    onGuestChange(id, updated);
  }

  const handleDelete = (ev) => {
    ev.preventDefault();
    onGuestDelete(id)
  }

  return (
    <div className="flex flex-row items-start md:items-center justify-between text-base gap-4">
      <div className="flex-grow flex flex-col md:flex-row gap-2 md:gap-6">
        <input className="flex-grow" type="text" name={`guest[${id}].name`} placeholder={"Name"} value={guest.name} onChange={handleChange}/>
        {
          isAttending &&
          <div className={"flex flex-row gap-6"}>
            <div className="flex flex-row gap-2 flex-wrap">
              <RadioButton name={`guest[${id}].food`}
                           value="vegetarisch"
                           label="Vegetarisch"
                           checked={guest.food === 'vegetarisch'}
                           onChange={handleChange}/>
              <RadioButton name={`guest[${id}].food`}
                           value="lachs"
                           label="Lachs"
                           checked={guest.food === 'lachs'}
                           onChange={handleChange}/>
              <RadioButton name={`guest[${id}].food`}
                           value="rind"
                           label="Rind"
                           checked={guest.food === 'rind'}
                           onChange={handleChange}/>
            </div>
            <Checkbox name={`guest[${id}].brunch`} checked={guest.brunch} label={"Brunch inklusive"} onChange={handleChange}/>
          </div>
        }
      </div>
      {
        canDelete &&
        <button onClick={handleDelete} className={"mt-2 md:mt-0 bg-white border border-red-400 text-red-400 rounded-full p-1 text-xs"}><FaMinus/></button>
      }
    </div>
  )
}

export default GuestInput
